<template>
  <div class="planning-outro" :class="{ 'is-ie': $browserDetect.isIE }">
    <div class="header">
      <p class="title">
        Préparer le planning des semaines à venir
      </p>
      <p class="sub-title">
        Arbitrer entre plusieurs plannings possibles
      </p>
    </div>
    <div class="answers-bloc">
      <p class="title">
        {{ scoreTitle }}
      </p>
      <div class="wrapper">
        <p class="annotation">Cliquez sur un planning pour voir son correctif</p>
        <div class="answers-wrapper">
          <button class="planning-button" :class="{ right: plannings[0].answer === plannings[0].goodAnswer, current: currentCorrection === 0 && showCorrection }" @click="toggleCorrection(0)">
            <span class="label">
              Planning N°1
            </span>
            <span class="answer" :class="{ good: plannings[0].answer, 'not-good': plannings[0].answer === false }">
              {{ plannings[0].answer ? 'Bon' : 'Pas bon' }}
            </span>
          </button>
          <button class="planning-button" :class="{ right: plannings[1].answer === plannings[1].goodAnswer, current: currentCorrection === 1 && showCorrection }" @click="toggleCorrection(1)">
            <span class="label">
              Planning N°2
            </span>
            <span class="answer" :class="{ good: plannings[1].answer, 'not-good': plannings[1].answer === false }">
              {{ plannings[1].answer ? 'Bon' : 'Pas bon' }}
            </span>
          </button>
          <button class="planning-button" :class="{ right: plannings[2].answer === plannings[2].goodAnswer, current: currentCorrection === 2 && showCorrection }" @click="toggleCorrection(2)">
            <span class="label">
              Planning N°3
            </span>
            <span class="answer" :class="{ good: plannings[2].answer, 'not-good': plannings[2].answer === false }">
              {{ plannings[2].answer ? 'Bon' : 'Pas bon' }}
            </span>
          </button>
        </div>
      </div>
    </div>
    <div class="correction-wrapper">
      <div class="correction-bloc" v-show="showCorrection">
        <div class="head">
          <div class="title-wrapper">
            <p class="title">Planning N°{{ currentPlanning.label }}</p>
            <div class="plan-status" :class="{ good: currentPlanning.goodAnswer, 'not-good': !currentPlanning.goodAnswer }">
              {{ currentPlanning.goodAnswer ? 'Bon' : 'Pas bon' }}
            </div>
          </div>
          <div class="correction">
            {{ currentPlanning.correction }}
          </div>
        </div>
        <div class="img-wrapper">
          <img :src="require(`../assets/plannings/${currentPlanning.image}`)">
        </div>
      </div>
      <div class="button-wrapper" :class="{ big: showCorrection }">
        <p class="title">
          Vous avez complété ce module.
        </p>
        <button class="button" @click="exit">Enregistrer et quitter</button>
      </div>
    </div>
  </div>
</template>

<script>
import stepMixin from '@shared/mixins/stepMixin'

export default {
  name: 'PlanningOutro',
  mixins: [stepMixin],
  data () {
    return {
      showCorrection: false,
      currentCorrection: 0
    }
  },
  computed: {
    score () {
      return this.$store.getters.score
    },
    plannings () {
      return this.$store.state.plannings
    },
    currentPlanning () {
      return this.plannings[this.currentCorrection]
    },
    scoreTitle () {
      if (this.score > 1) {
        return `Vous avez ${this.score} bonnes réponses !`
      } else if (this.score === 1) {
        return 'Vous n’avez qu’une bonne réponse'
      } else {
        return 'Vous n’avez aucune bonne réponse...'
      }
    }
  },
  methods: {
    toggleCorrection (index) {
      if (this.currentCorrection === index && this.showCorrection) {
        this.showCorrection = false
      } else {
        this.showCorrection = true
        this.currentCorrection = index
      }
    }
  }
}
</script>

<style lang="scss">
.planning-outro {
  .header {
    width: 1024px;
    margin: 0 auto;
    padding-top: 20px;
    text-align: left;
    .title {
      font-family: $secondary-font;
      font-weight: 700;
      font-size: 0.95rem;
      color: $secondary-text-color;
    }
    .sub-title {
      margin-top: 10px;
      font-size: 1.9rem;
    }
  }
  .answers-bloc {
    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.16);
    background-color: #fff;
    width: 608px;
    margin: 20px auto 0 auto;
    padding: 8px;
    text-align: left;
    .title {
      margin-left: 15px;
      margin-top: 10px;
      margin-bottom: 15px;
      font-weight: 700;
      font-size: 1.3rem;
    }
    .wrapper {
      background-color: $background-color;
      border-radius: $radius-md;
      padding: 15px 5px 10px 5px;
      .annotation {
        font-family: $secondary-font;
        font-weight: 700;
        color: $secondary-text-color;
        margin-bottom: 15px;
        padding-left: 10px;
        font-size: 0.95rem;
      }
    }
    .answers-wrapper {
      display: flex;
      .planning-button + .planning-button {
        margin-left: 4px;
      }
      .planning-button {
        font-family: $primary-font;
        flex: 1 1 0;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 2px 1px 5px rgba(128, 128, 128, 0.25);
        border-radius: $radius;
        background-color: rgba(255, 255, 255, 0.85);
        height: 60px;
        padding: 2px;
        font-weight: 700;
        font-size: 0.9rem;
        cursor: pointer;
        border: 1px solid #ff1010;
        color: #ff1010;
        position: relative;
        &.current {
          background-color: darken(#ff1010, 10);
          color: #fff;
        }
        .label {
          font-weight: 700;
          text-align: center;
          font-size: 0.95rem;
        }
        .answer {
          position: absolute;
          left: 50%;
          color: #fff;
          height: 25px;
          width: 110px;
          background-color: $primary-color;
          display: flex;
          align-items: center;
          justify-content: center;
          bottom: -12px;
          transform: translateX(-50%);
          background-position: left 15px center;
          background-repeat: no-repeat;
          padding-left: 15px;
          font-weight: 700;
          font-size: 0.85rem;
          background-size: 15px;
          &.good {
            background-image: url('../assets/good-white.svg');
          }

          &.not-good {
            background-image: url('../assets/not-good-white.svg');
          }
        }
        &.right {
          border: 1px solid #1bb91f;
          color: #1bb91f;
          &.current {
            background-color: #16911a;
            color: #fff;
          }
          .label {
            font-weight: 700;
          }
        }
      }
    }
  }
  .correction-bloc {
    .head {
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: $primary-color;
      color: #fff;
      padding: 15px 0;
      .title-wrapper {
        min-width: 230px;
        padding: 0 45px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .title {
          font-weight: 700;
          font-size: 1.4rem;
          margin-bottom: 10px;
        }
        .plan-status {
          height: 30px;
          width: 120px;
          background-color: #fff;
          color: $secondary-color;
          display: flex;
          align-items: center;
          justify-content: center;
          background-position: left 15px center;
          background-repeat: no-repeat;
          padding-left: 15px;
          font-weight: 700;
          font-size: 0.9rem;
          &.good {
            background-image: url('../assets/good.svg');
          }
          &.not-good {
            background-image: url('../assets/not-good.svg');
          }
        }
      }
      .correction {
        line-height: 1.4rem;
        text-align: left;
        font-family: $secondary-font;
        font-size: 0.95rem;
        padding-right: 15px;
      }
    }
    .img-wrapper {
      max-width: 100%;
      img {
        width: 100%;
      }
    }
  }
  .correction-wrapper {
    display: flex;
    flex-direction: column;
  }
  .button-wrapper {
    display: flex;
    flex-direction: column;
    min-width: 608px;
    background-color: $primary-color;
    padding: 25px 0;
    border-radius: $radius;
    margin: 20px auto 0 auto;
    &.big {
      margin: 20px 25px 20px 25px;
    }
    .title {
      display: inline-block;
      color: #fff;
      font-weight: 700;
      font-size: 1.6rem;
      margin-bottom: 20px;
    }
    .button {
      margin: 0 auto;
    }
  }
  &.is-ie {
    .correction-wrapper {
      .correction-bloc {
        height: 100%;
      }
    }
      .button-wrapper {
      margin: 20px;
      .button {
        max-width: 200px;
      }
    }
  }
}
</style>
